// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ExternalAgentStore, for use in the registry */ export const ExternalAgentStoreActionTypes = [
    ActionType.FetchExternalAgentsAction,
    ActionType.FetchExternalAgentsFailedAction,
    ActionType.FetchExternalAgentsSucceededAction
];
